module.exports = __webpack_public_path__ + "static/media/ro.af9e2aae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ro.svg
// module id = 234
// module chunks = 0